import DailyBoxUpdate from './DailyBoxUpdate'
export {DailyBoxUpdate}
export default DailyBoxUpdate
